import React, { Component } from "react";
import Proptypes from "prop-types";

export default class ViewAwsDnsProviderConfig extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        const { currentDnsProviderConfig } = this.props;
        return (
            <React.Fragment>
                <tr><td><h4>Name</h4></td><td>{currentDnsProviderConfig.config_name || "-"}</td></tr>
                <tr><td><h4>Access Key ID</h4></td><td>{currentDnsProviderConfig.aws_access_key_id}</td></tr>
                <tr><td><h4>Access Key Secret</h4></td><td>{currentDnsProviderConfig.aws_secret_access_key}</td></tr>
            </React.Fragment>
        );
    }
}

ViewAwsDnsProviderConfig.propTypes = {
    currentDnsProviderConfig: Proptypes.object.isRequired,
};
